<template>  
	<div>    
		<p><strong>Action Plan:</strong></p> 
		<p> 
			Based on the information you entered, body 
			mass index (BMI) is {{bmi}} kg/m2 and unplanned 
			weight loss % is {{percentage}} %. This suggests a <strong>LOW</strong> risk of 
			being malnourished. 
		</p>
		<p><strong>Local Guidance</strong></p>
		<p>
			<a href="https://manual.rightdecision.scot.nhs.uk/media/1346/dumfries-and-galloway-nutritional-care-assessment-guidelines-for-care-and-nursing-homes-update-may2021-002.pdf" target="_blank">NHS Dumfries and Galloway</a>
		</p>
		<p>
			<strong>National guidance from  <a href="https://www.bapen.org.uk/pdfs/must/must_explan.pdf" target="_blank">BAPEN MUST Explanatory booklet</a></strong>
		</p>
		<p><strong><em>Low risk: Routine clinical care</em></strong></p> 
		<p><strong>Repeat screeing</strong></p>
		<ul>
			<li>Hospital - weekly</li>
			<li>Home - monthly</li>
			<li>Community - annually for special groups, e.g. those >75 yrs</li> 
		</ul>
		<p>
			All risk categories:
		</p>
		<ul>
			<li>
				Treat underlying condition and 
				provide help and advice on food 
				choices, eating and drinking 
				when necessary. 
			</li>
			<li>
				Record malnutrition risk 
				category.
			</li>
			<li> 
				Record need for special diets and 
				follow local policy. 
			</li>
		</ul>
		<p>
			Obesity:
		</p>
		<p>
			Record presence of obesity. For those with 
			underlying conditions, these are generally 
			controlled before the treatment of obesity.
		</p>
		<p>
			<strong>Re-assess subjects identified at risk as they 
			move through care settings.</strong>
		</p>
	</div>
</template>

<script>
	export default {
		name: "Low",
		props: {
			bmi: String,
			percentage: String
		},
		methods: {					
			handleClick(e) {
				if (e.target.matches("a")) {
					let url = e.target.href;
					let target = e.target.target == "_blank" ? "_blank" : "_self";
					let dataId = e.target.dataset.id == null ? -1 : e.target.dataset.id;
					var isnativeapp = document.getElementById("isnativeapp");
					if (isnativeapp === undefined || isnativeapp === null) 
					{
						window.open(url,target);  
					}
					else{
						if(target == "_blank") {
							let data = {title:'',nodeid: dataId, href:url, target: target};
							window.Native('dataCallback', data);
						} 
					}	
				}
			},
		}
	};
</script>
